import '@fontsource-variable/inter'
import './assets/fonts/gilroy/gilroy.css'
import '@fontsource/poppins/300.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/700.css'
import './i18n'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './pages/App'
import { CssBaseline, ThemeProvider } from '@mui/material'
import theme from './theme'
import { init_sentry } from './sentryConfig'
import { getEnvironment } from './utils/environment'
import { dropTagManager } from './utils/tagManager'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import PasswordSetupStep from './pages/PasswordSetup'
import RouteErrorBoundary from './pages/RouteErrorBoundary'
import Signup from './pages/Signup'
import SignupComplete from './pages/SignupComplete'
import { ConsoleManager } from './services/console/ConsoleManager'
import { initChunkErrorListener } from './services/error/ChunkErrorListener'
import { initTranslationCrashGuard } from './services/error/TranslationCrashGuard'

initChunkErrorListener()
initTranslationCrashGuard()

const environment = getEnvironment()
console.info('Environment: ' + environment)

if (environment === 'production') {
    ConsoleManager.getInstance().disableLogging()
}

init_sentry(environment)

// Data router (instead of <BrowserRouter>) so useBlocker can guard route changes while recording
const router = createBrowserRouter([
    {
        errorElement: <RouteErrorBoundary />,
        children: [
            { path: '/password-setup', element: <PasswordSetupStep /> },
            { path: '/signup', element: <Signup /> },
            { path: '/signup/complete', element: <SignupComplete /> },
            { path: '/*', element: <App />, loader: dropTagManager },
        ],
    },
])

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router} />
    </ThemeProvider>
)
